import {
  OutlinedInput as MuiOutlinedInput,
  OutlinedInputProps,
  InputAdornment,
  SxProps,
  Theme,
  FormHelperText
} from "@mui/material"
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined"
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined"
import React, { useState } from "react"
import Stack from "../stack"
import Label from "../label"
export type IOutlinedInput = {
  type?: string
  label?: string
  required?: boolean
  primaryLabel?: boolean
  labelWeight?: number
  error?: boolean
  helperText?: string
  labelSx?: SxProps<Theme>
  labelColor?: string
  onChange?: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    value?: string | number | boolean
  ) => any
  labelMb?: number
} & Omit<OutlinedInputProps, "onChange">

const OutlinedInput = React.forwardRef(
  (
    {
      type,
      required,
      label,
      primaryLabel,
      labelWeight,
      error,
      helperText,
      sx,
      labelSx,
      labelColor,
      onChange,
      fullWidth,
      labelMb,
      ...rest
    }: IOutlinedInput,
    ref?: any
  ) => {
    const sxProps = {
      ...sx,
      ...(rest.size === "small" && ({ fontSize: (theme) => theme.typography.body2.fontSize } as SxProps<Theme>))
    }
    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      let inputValue = event?.target?.value

      // Type enforcement logic
      let parsedValue: string | number | boolean
      switch (type) {
        case "integer":
          parsedValue = inputValue === "" ? "" : parseInt(inputValue, 10) // Integer conversion
          break

        case "number":
          parsedValue = inputValue === "" ? "" : Number(inputValue) // Float conversion
          break

        default:
          parsedValue = inputValue
      }
      onChange?.(event, parsedValue)
    }

    const [showPassword, setShowPassword] = useState(false)
    return (
      <Stack sx={{ width: fullWidth ? "100%" : undefined }}>
        <Label
          mb={labelMb}
          label={label}
          labelWeight={labelWeight}
          labelColor={(labelColor ?? error) ? "error" : labelColor}
          required={required}
          labelSx={labelSx}
        />
        {type === "password" ? (
          <MuiOutlinedInput
            {...rest}
            required={required}
            type={showPassword ? "text" : "password"}
            error={error}
            sx={sxProps}
            onChange={onChange}
            fullWidth={fullWidth}
            endAdornment={
              <InputAdornment
                position="end"
                onClick={() => {
                  setShowPassword((prev) => !prev)
                }}
              >
                {showPassword ? (
                  <VisibilityOutlinedIcon fontSize="small" />
                ) : (
                  <VisibilityOffOutlinedIcon fontSize="small" />
                )}
              </InputAdornment>
            }
          />
        ) : type !== "password" ? (
          <MuiOutlinedInput
            {...rest}
            sx={sxProps}
            fullWidth={fullWidth}
            onChange={handleChange}
            type={type}
            inputRef={ref}
            required={required}
            error={error}
          />
        ) : (
          <></>
        )}
        {error ? (
          <FormHelperText sx={{ fontSize: (theme) => theme.typography.subtitle2.fontSize }} error>
            {helperText}
          </FormHelperText>
        ) : (
          <></>
        )}
      </Stack>
    )
  }
)

export default OutlinedInput
